import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { smartChargingClient } from '@integration/api-client/smart-charging';

export const { actions, effects } = generateNgrxServiceClient(
  '[Smart Charging]',
  smartChargingClient
);
